export const S3_DOMAIN = process.env.REACT_APP_STORAGE_URL || '';
export const CDN_DOMAIN = process.env.REACT_APP_CDN_URL || '';

export const SCROLL_INTO_VIEW_DELAY_TIME_MS = 200;
export const DEBOUNCE_TIME_MS = 400;
